export default {
  filter: {
    selectDepartment: '筛选部门',
    selectedDepartments: '已选择部门',
    more: '查看更多'
  },
  overview: {
    summary: '概况统计',
    fillingStatus: '填写情况',
    publishedNum: '发布人数',
    unpublishedNum: '填写未发布人数',
    staffNum: '在职总人数',
    fillingRate: '填写率',
    alignStatus: '对齐情况',
    alignedNum: '对齐人数',
    alignRate: '对齐率',
    updateStatus: '更新情况（本月内）',
    updatedNum: '更新人数',
    updateRate: '更新率',
    reviewStatus: '复盘情况',
    reviewedNum: '复盘人数',
    reviewRate: '复盘率'
  },
  table: {
    title: '统计表',
    batchRemind: '批量提醒',
    total: '共 {count} 条',
    filter: {
      name: '姓名',
      publishedStatus: '发布状态',
      alignedStatus: '对齐状态',
      updatedStatus: '更新状态',
      reviewedStatus: '复盘状态',
      options: {
        published: '已发布',
        unpublished: '未发布',
        aligned: '已对齐',
        unaligned: '未对齐',
        updated: '已更新',
        unupdated: '未更新',
        unreviewed: '未复盘',
        reviewed: '已复盘'
      }
    },
    column: {
      name: '姓名',
      department: '部门',
      fillingStatus: '填写状态',
      publishedStatus: '发布状态',
      alignedStatus: '对齐状态',
      alignedNum: '对齐数量',
      updatedStatus: '当月更新状态',
      lastUpdatedTime: '最近更新时间',
      reviewedStatus: '复盘状态',
      lastReviewedTime: '最近复盘时间',
      lastRemindTime: '最后提醒时间',
      action: '操作'
    },
    remind: {
      name: '提醒',
      label: '选择提醒类型',
      fill: '填写',
      align: '对齐',
      update: '更新',
      review: '复盘',
      successMessage: '提醒员工成功'
    },
    data: {
      未填写: '未填写',
      已填写: '已填写',
      未发布: '未发布',
      已发布: '已发布',
      未对齐: '未对齐',
      已对齐: '已对齐',
      未更新: '未更新',
      已更新: '已更新',
      未复盘: '未复盘',
      已复盘: '已复盘'
    }
  },
  statesChart: {
    title: '状态分析',
    顺利: '顺利',
    拖延: '拖延',
    风险: '风险',
    放弃: '放弃'
  },
  departmentsChart: {
    title: '部门对比分析',
    填写率: '填写率',
    对齐率: '对齐率',
    更新率: '更新率',
    复盘率: '复盘率'
  }
}
